export const redirectToNewDomain = () => {
  const path = window.location.pathname ?? "";

  const domainsToRedirect = [
    "comuapp.web.app",
    "comu-dev.web.app",
    "comuapp.firebaseapp.com",
    "comu-dev.firebaseapp.com"
  ];

  const hostname = window.location.hostname;

  const shouldRedirect = domainsToRedirect.some((domain) => hostname.includes(domain));

  if (shouldRedirect) {
    window.location.href = `http://comu-app.com${path}${window.location.search}${window.location.hash}`;
  }
};
